import React from 'react';
import {useTypedSelector} from '@common/hooks/useTypedSelector';
import Link from 'next/link';
import {useTranslation} from '@common/hooks/useTranslation';
import {ITranslation} from '@common/types';
import NewsGrid from '@modules/News/components/NewsGrid';
import Text from '@common/components/common/Text';


export const News = () => {
  const {page, news = []} = useTypedSelector(state => state.news);
  const {contacts} = useTypedSelector(state => state.contacts);
  const t = useTranslation('news') as ITranslation['news'];

  return (
    <section className="news-content">
      <div className="container">
        <h1 className="news-content__title">
          <Text text={page?.title}/>
        </h1>

        <ul className="news-content__links">
          <li className="news-content__item">
            <Link
              className="news-content__link" href={contacts?.socialUrls?.telegram || '#'}
              aria-label={t.telegram.label}
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              {t.telegram.title}
            </Link>
          </li>
          <li className="news-content__item">
            <Link
              className="news-content__link" href={contacts?.socialUrls?.youtube || '#'}
              aria-label={t.youtube.label}
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              {t.youtube.title}
            </Link>
          </li>
          <li className="news-content__item">
            <Link
              className="news-content__link" href={contacts?.socialUrls?.vk || '#'}
              aria-label={t.vk.label}
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              {t.vk.title}
            </Link>
          </li>
        </ul>

        <NewsGrid news={news}/>
      </div>
    </section>
  )
}
